import { Menu, Text } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ShortcutAction } from 'app/modules/wallforming/components/scenes/toolbar/types/shortcutAction';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const Delete = () => {
    const { t } = useTranslation();

    const { articleInstanceSelections, discardArticleInstanceSelection } = usePlacementStore(
        useShallow((state) => ({
            articleInstanceSelections: state.articleInstanceSelections,
            discardArticleInstanceSelection: state.discardArticleInstanceSelection
        }))
    );

    const selectedInstanceIds = useMemo(() => Object.keys(articleInstanceSelections), [articleInstanceSelections]);

    return (
        <Menu.Item
            disabled={selectedInstanceIds.length === 0}
            leftSection={
                <Icon className="action-menu-entry-decoration action-menu-entry-decoration-icon" icon="delete" />
            }
            rightSection={<Text className="action-menu-entry-decoration-text text-right text-[13px]">{ShortcutAction.Delete}</Text>}
            onClick={() => discardArticleInstanceSelection(true)}
        >
            {t('delete')}
        </Menu.Item>
    );
};
